import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async deletePhoto({ dispatch, commit }, { id }) {
    try {
      this.isLoading = true;
      const { data } = await request.delete(`/photos/${id}`, data);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
